/* eslint-disable react/jsx-no-duplicate-props */
import React from 'react';
import * as Yup from 'yup';
import * as P from 'prop-types';
import { omit } from 'ramda';
import {
  FormControl, FormHelperText, InputLabel, MenuItem, Select,
} from '@material-ui/core';
import { propTypes, defaultProps } from '../Utils/TextFieldPropTypes';

export default function InputIssuers({
  handleChange, disabled, selected,
  error, typeInput, options,
}) {
  const selectRef = React.useRef();
  const handleSelectChange = ({ target }) => {
    handleChange({ currentTarget: selectRef.current, value: target });
  };

  return (
    <div id="issuerInput">
      <select
        hidden
        id="issuer"
        name="issuer"
        data-checkout="issuer"
        ref={selectRef}
      >
        {
          options.map((opt) => (
            <option key={opt.value} value={opt.value}>{opt.text}</option>
          ))
        }
      </select>
      <FormControl
        fullWidth
        size="small"
        variant={typeInput}
        error={!!error}
        disabled={!options.length || disabled}
      >
        <InputLabel>Emissor</InputLabel>
        <Select value={selected?.value ?? ''} onChange={handleSelectChange}>
          {
            options.map((opt) => (
              <MenuItem key={opt.value} value={opt.value}>{opt.text}</MenuItem>
            ))
          }
        </Select>
        {!!error && (
          <FormHelperText>{error}</FormHelperText>
        )}
      </FormControl>
    </div>
  );
}

InputIssuers.propTypes = {
  ...omit(
    ['handleBlur', 'value'],
    propTypes,
  ),
  selected: P.shape({
    value: P.oneOfType([P.string, P.number]),
    text: P.string,
  }),
  options: P.arrayOf(P.shape({
    value: P.oneOfType([P.string, P.number]).isRequired,
    text: P.string.isRequired,
  })),
};
InputIssuers.defaultProps = defaultProps;
InputIssuers.rules = Yup.string().required('Este campo é obrigatório');
